<wbo-edit-page #editPage [title]="model.data.name">
    <fui-formation-group-template *formationGroup="{title: 'wbo.inventory-group.edit.formation.inventoryGroupDetails', formControlNames: ''}">
        <fui-rows [formGroup]="editPage.formGroup">
            <fui-two-columns>
                <fui-column>
                    <wbo-text-edit-control formControlName="name" [(ngModel)]="model.data.name">
                    </wbo-text-edit-control>
                </fui-column>
                <fui-column>
                    <wbo-checkbox-edit-control formControlName="nonStockable" [(ngModel)]="model.data.nonStockable"></wbo-checkbox-edit-control>
                </fui-column>
            </fui-two-columns>
        </fui-rows>
    </fui-formation-group-template>
</wbo-edit-page>
